import { useState } from 'react';

export default function useToken() {
  const getToken = () => {
    console.log('get token');
    const tokenString = localStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('token', JSON.stringify(userToken));
    setToken(userToken.token);
  };

  const removeToken = () => {
    localStorage.removeItem('token');
    setToken(null);
  };

  return {
    unsetToken: removeToken,
    setToken: saveToken,
    token
  }
}
 
